export const PROPOSAL_COLUMNS = [
    'ARCIMEDES_ROW_ID',
    'PROPERTY_ID',
    'STRENGTHS',
    'CHALLENGES',
    'BUYER_POOL',
    'QUALIFICATIONS',
    'RECOMMENDATIONS',
    'UPDATED'
]

export const PROPERTY_COLUMNS = [
    "ARCIMEDES_ROW_ID", "DELETED", "SOURCE", "TRANSACTION_TYPE", "STATUS", "VISIBLE", "FEATURED", "FEATURED_DATE",
    "NAME", "ADDRESS", "CITY", "STATE", "ZIP", "LATITUDE",
    "LONGITUDE", "HIGHLIGHTS", "MEDIA_KIT", "TYPE", "SQFT", "LIST_PRICE", 
    "NET_OPERATING_INCOME", "VACANCY", "CAPITALIZATION_RATE", "SOLD_PRICE", 
    "DOWN_PAYMENT", "CLOSE_OF_ESCROW", "LISTED_DATE", "SELLER_FEE_PERCENTAGE", 
    "TOTAL_FEE", "LEASE_TYPE", "LEASE_COMMENCEMENT_DATE", "LEASE_EXPIRATION_DATE", 
    "SELLER_ID", "BUYER_ID", "YEAR_BUILT", "VIDEO_URL", "FLIP_BOOK", "CLOSE_NOI", 
    "PROFORMA_NOI", "PROFORMA_BASE_RENT", "PROFORMA_CAP_RATE", "CLOSE_CAP_RATE", 
    "CLOSE_PRICE_PER_SQFT", "PRICE_PER_SQFT", "LISTING_AGENT_1", "LISTING_AGENT_2", 
    "LISTING_AGENT_3", "LISTING_AGENT_4", "LISTING_AGENT_4_FIRM", "BUYER_AGENT_1", 
    "BUYER_AGENT_2", "BUYER_AGENT_3", "BUYER_AGENT_4", "BUYER_AGENT_4_FIRM", 
    "LISTING_AGENT_1_PERCENT", "LISTING_AGENT_2_PERCENT", "LISTING_AGENT_3_PERCENT", 
    "LISTING_AGENT_4_PERCENT", "BUYER_AGENT_1_PERCENT", "BUYER_AGENT_2_PERCENT", 
    "BUYER_AGENT_3_PERCENT", "BUYER_AGENT_4_PERCENT", "SINGLE_TENANT_SUBCATEGORY", 
    "MULTI_TENANT_SUBCATEGORY", "TENANT_ID", "MARKET", "RENT_PER_SQFT", 
    "NEGOTIATION_PRICE", "POTENTIAL_FEE", "LIST_FEE", "BUYSIDE_FEE", 
    "NEGOTIATION_CAP_RATE", "CATEGORY", "HIDE_FINANCIALS", "IS_PROFORMA_PRICING", 
    "DATE_REMOVED", "NEGOTIATION_PRICE_PER_SQFT", "BASE_RENT", 
    "EXPIRATION_NO_OF_MONTHS", "EXPIRATION_DATE", "EFFECTIVE_DATE", "REFERRAL_FEE", 
    "HSC_TEAM_MEMBER_1", "HSC_TEAM_MEMBER_1_PERCENT", "HSC_TEAM_MEMBER_1_NET_FEE", 
    "HSC_TEAM_MEMBER_1_NET_PERCENT", "HSC_TEAM_MEMBER_1_GROSS_FEE", 
    "HSC_TEAM_MEMBER_2", "HSC_TEAM_MEMBER_2_PERCENT", "HSC_TEAM_MEMBER_2_NET_FEE", 
    "HSC_TEAM_MEMBER_2_NET_PERCENT", "HSC_TEAM_MEMBER_2_GROSS_FEE", 
    "HSC_AGREEMENT_FILE", "LOAN_COMMITMENT_FILE", "CLOSING_STATEMENT_FILE", 
    "LOAN_CLOSING_DATE", "HSC_APPROVED", "HSC_APPROVED_TIMESTAMP", 
    "HSC_APPROVED_INITIALS", "HSC_STATUS", "HSC_PRICE", "HSC_LISTED_DATE", 
    "HSC_EXPIRATION_NO_OF_MONTHS", "HSC_EXPIRATION_DATE", "HSC_FEE_PERCENTAGE", 
    "HSC_TOTAL_FEE", "HSC_LIST_FEE", "LENDER_ID", "LENDER_CONTACT_ID", "LOAN_TYPE", "LTV", 
    "LOAN_AMOUNT", "INTEREST_RATE", "AMORTIZATION", "TERM", "MATURITY", "MATURITY_DATE",
    "ANNUAL_LOAN_PAYMENT", "CASH_FLOW", "CASH_ON_CASH", "DSCR", "PREPAYMENT_PENALTY", 
    "CREDITS_AT_CLOSING", "REFERRAL", "REFERRAL_PERCENT", "NOI_PERCENT", 
    "REFERRED_BY_ID", "REFERRED_BY_TYPE", "REFERRAL_TYPE", "HSC_FINANCING", 
    "DATE_CREATED", "APN", "OTHER_FINANCING", "NOTES", "REP_AGREEMENT_FILE_1", 
    "REP_AGREEMENT_FILE_2", "REP_AGREEMENT_FILE_3", "REP_AGREEMENT_FILE_4", 
    "REP_AGREEMENT_FILE_5", "IN_NEG_FILE_1", "IN_NEG_FILE_2", "IN_NEG_FILE_3", 
    "IN_NEG_FILE_4", "IN_NEG_FILE_5", "SELLER_STATEMENT_FILE", 
    "BUYER_STATEMENT_FILE", "WEBSITE_PHOTO_1", "WEBSITE_PHOTO_2", 
    "WEBSITE_PHOTO_3", "WEBSITE_PHOTO_4", "WEBSITE_PHOTO_5", "CREATED_BY", 
    "FLAGGED_DATE", "UNDER_CONTRACT_IN_NEGOTIATION_SINCE", "PROPERTY_INFO_SINCE",
    "OFF_MARKET_SINCE", "COURTING_SINCE", "LAST_MODIFIED_BY", "LAST_MODIFIED_DATE",
    "UPLOADED_FROM", "IS_LISTING", "WAS_PROPOSAL", "ESTIMATED_PRICE_TYPE", 
    "SUB_CATEGORY", "UNITS", "PROPOSAL_DATE", "BANK_BONUS", "BANK_BONUS_PERCENT",
    "STREET", "COUNTY", "ASSESSED_VALUE", "ASSESSED_YEAR", "ACRES",
    "TRANS_DATE", "TRANS_PRICE", "LEGAL_DESC", "CAD_SITE", "CORE_PROPERTY", "NEED_INFO"
];